import { useState, useEffect, Children } from "react";
import { Grid } from "@mui/material";
import Statistical from "./Statistical/Statistical";
import sharedService from "../../../../Services/SharedService";
import Map from "./Map/Map";
import { BuildChartData, adjustRAData, METRIC_GROUPS } from "../../../Components/Chart/Component/chart_data";
import { calculateQS as CalculateFlowSpin } from "../../../Components/Chart/Component/chart_data";
import { CalculateFlow as CalculateFlowDrain } from "../../../Components/Interpolation/drain";

import { GetUnit } from "../../../../Utils/helper";
import LineChart from "../../../Components/Chart/Component/LineChart";
import BarChart from "../../../Components/Chart/Component/BarChart";
import WaterLevelView from "../../../Components/Chart/Component/WaterLevelView";
import MultiLineChart from "../../../Components/Chart/Component/MultiLineChart";

const DashBoardSL = ({ group, center, isLoading, records }) => {
    const [charts, setCharts] = useState();

    const [dataWaterLevelView, setDataWaterLevelView] = useState()

    function findMissingTimestamps(timestamps) {
        const ONE_HOUR = 3600;
        if (!timestamps.length) return [];

        // Lấy mốc giờ chẵn gần nhất (theo thời gian hiện tại)
        const now = Math.floor(Date.now() / 1000);
        const currentHour = Math.floor(now / ONE_HOUR) * ONE_HOUR;

        // Sinh ra danh sách 24 giờ gần nhất (lùi từng 1 tiếng)
        const expected = [];
        for (let i = 0; i < 24; i++) {
            expected.push(currentHour - i * ONE_HOUR);
        }

        // Tìm xem giờ nào bị thiếu trong dữ liệu
        const missing = expected.filter(t => !timestamps.includes(t));

        return missing.sort((a, b) => b - a); // sắp xếp giảm dần (mới nhất trước)
    }

    useEffect(async () => {
        let z; // Ztl
        let dr; // độ mở cống
        let q; // lưu lượng
        const groupRecord = await (await sharedService.listRecordBoxGroup()).data;

        // Thông số hiện tại
        groupRecord.map(g => {
            if (g.count === 0) return;
            if (g.box.id === 'WK34ZRT9') {
                const record = g.records[0]
                z = record?.WAU
                q = CalculateFlowSpin(record, z)
            }
            if (g.box.id === 'R8ZLNSJX') {
                dr = g.records[0]?.DR1 / 1000
            }
            if (g.box.type === "RA" && g.count < 24) {
                const allTimestamps = []
                g.records.forEach(r => allTimestamps.push(r.t))
                const missing = findMissingTimestamps(allTimestamps)
                missing.forEach(m => g.records.push({ t: m, RA: 0 }))
                g.records.sort((a, b) => b.t - a.t)
            }
            return g
        })
        const dataWLV = { z, q, q_of: CalculateFlowDrain(dr, z) || 0 }
        setDataWaterLevelView(dataWLV)
        //////
        const result = groupRecord.map(g => {
            const chart = BuildChartData(g.records, g.box, z)
            return chart
        })

        const docs = adjustRAData(result.filter(r => r))
        setCharts(docs)
    }, [])

    return (
        <>
            <Grid container columns={12} className="DashBoardSL">
                {/* <Grid
                    item
                    xs={12}
                    lg={4}
                    sx={{
                        marginTop: { xs: '20px', md: '0px' },
                        display: { xs: 'block', lg: 'none' },
                    }}>
                    <Statistical data={records} />
                </Grid> */}
                <Grid
                    item
                    xs={12}
                    lg={4}
                    sx={{
                        marginTop: { xs: '50px', lg: '0px' }
                    }}
                    className="list-chart"
                >
                    {charts && Children.toArray(charts.filter(c => c.metric !== "WAU" && !(c.metric === "DR" && !c.datasets.some(d => d.code === "DR3")))
                        .sort((a, b) => {
                            if (b.type === "bar") return -1
                        })
                        .map(t => {
                            // if (t.metric === "WAU") return <div className="water-section"><WaterLevelView box_id={t.box_id} data={dataWaterLevelView} /></div>
                            if (t.type === 'line' && t.metric !== 'WA') return <div className="chart-container">
                                <p>Biểu đồ dữ liệu {METRIC_GROUPS.find(m => m.metric === t.metric).label} {GetUnit(t.metric)}</p>
                                <div className="chart-item">
                                    <LineChart height='100%' data={t} />
                                </div>
                            </div>
                            else if (t.type === 'bar') return <div className="chart-container">
                                <p>Biểu đồ dữ liệu {METRIC_GROUPS.find(m => m.metric === t.metric).label} {GetUnit(t.metric)}</p>
                                <div className="chart-item">
                                    <BarChart height='100%' data={t} />
                                </div>
                            </div>
                            else if (t.type === "multiLine") return <div className="chart-container">
                                <p>Biểu đồ dữ liệu đo mở tràn</p>
                                <div className="chart-item">
                                    <MultiLineChart height='100%' data={t} />
                                </div>
                            </div>
                        }))}
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={4}
                    sx={{
                        display: { xs: 'block', lg: 'block' }
                    }}>
                    <div className="list-chart2">
                        {charts && Children.toArray(charts.map(t => {
                            if (t.metric === "DR" && !t.datasets.some(d => d.code === "DR3")) return <div className="chart-container">
                                <p>Biểu đồ dữ liệu {METRIC_GROUPS.find(m => m.metric === t.metric).label}  </p>
                                <div className="chart-item">
                                    <MultiLineChart height='100%' data={t} />
                                </div>
                            </div>
                        }))}
                    </div>
                    <Statistical data={records} />
                </Grid>
                <Grid item xs={12} lg={4} sx={{ maxWidth: '1000px', minWidth: '260px', width: '200px', marginTop: { xs: '20px', lg: '0px' } }}>
                    {charts && Children.toArray(charts.filter(c => c.metric == "WAU").map(t => {
                        if (t.metric === "WAU") return <div className="water-section"><WaterLevelView box_id={t.box_id} data={dataWaterLevelView} /></div>
                    }))}
                    <Map group={group} center={center} isLoading={isLoading} />
                </Grid>
            </Grid>
        </>
    )
}

export default DashBoardSL;